const SAVE_NEW_TRANSACTION = 'SAVE_NEW_TRANSACTION';
const GET_PAYMENT_TRANSACTION = 'GET_PAYMENT_TRANSACTION';
const SET_PAYMENT_TRANSACTION = 'SET_PAYMENT_TRANSACTION';
const GET_CONFIG_TRANSACTION = 'GET_CONFIG_TRANSACTION';
const SET_CONFIG_TRANSACTION = 'SET_CONFIG_TRANSACTION';
const APPLY_PAYMENT_TRANSACTION = 'APPLY_PAYMENT_TRANSACTION';
const SAVE_USER_NEW_TRANSACTION = 'SAVE_USER_NEW_TRANSACTION';
const APPLY_USER_PAYMENT_TRANSACTION = 'APPLY_USER_PAYMENT_TRANSACTION';
const SAVE_USER_FREE_PACKAGE = 'SAVE_USER_FREE_PACKAGE';
const STAMP_PACKAGE_INVOICE = 'STAMP_PACKAGE_INVOICE';
const SHOW_STAMP_INVOICE_MODAL = 'SHOW_STAMP_INVOICE_MODAL';

const saveNewTransaction = data => {
    return {
        type: SAVE_NEW_TRANSACTION,
        data
    };
}

const getPaymentTransaction = data => {
    return {
        type: GET_PAYMENT_TRANSACTION,
        data
    }
}

const setPaymentTransaction = data => {
    return {
        type: SET_PAYMENT_TRANSACTION,
        data
    }
}

const getConfigTransaction = data => {
    return {
        type: GET_CONFIG_TRANSACTION,
        data
    }
}

const setConfigTransaction = data => {
    return {
        type: SET_CONFIG_TRANSACTION,
        data
    }
}

const applyPaymentTransaction = data => {
    return {
        type: APPLY_PAYMENT_TRANSACTION,
        data
    }
}

const saveUserNewTransaction = data => {
    return {
        type: SAVE_USER_NEW_TRANSACTION,
        data,
    }
}

const applyUserPaymentTransaction = data => {
    return {
        type: APPLY_USER_PAYMENT_TRANSACTION,
        data
    }
}

const saveUserFreePackage = data => {
    return {
        type: SAVE_USER_FREE_PACKAGE,
        data
    };
}

const stampPackageInvoice = data => {
    return {
        type: STAMP_PACKAGE_INVOICE,
        data
    }
}

const showStampInvoiceModal = status => {
    return {
        type: SHOW_STAMP_INVOICE_MODAL,
        status
    };
}


export default {
    types: {
        SAVE_NEW_TRANSACTION,
        GET_PAYMENT_TRANSACTION,
        SET_PAYMENT_TRANSACTION,
        GET_CONFIG_TRANSACTION,
        SET_CONFIG_TRANSACTION,
        APPLY_PAYMENT_TRANSACTION,
        SAVE_USER_NEW_TRANSACTION,
        APPLY_USER_PAYMENT_TRANSACTION,
        SAVE_USER_FREE_PACKAGE,
        STAMP_PACKAGE_INVOICE,
        SHOW_STAMP_INVOICE_MODAL
    },    
    actions: {
        saveNewTransaction,
        getPaymentTransaction,
        setPaymentTransaction,
        getConfigTransaction,
        setConfigTransaction,
        applyPaymentTransaction,
        saveUserNewTransaction,
        applyUserPaymentTransaction,
        saveUserFreePackage,
        stampPackageInvoice,
        showStampInvoiceModal
    }
}